import React, { useState, useEffect } from 'react'

const SearchBar = ({ searchTerm, setSearchTerm, placeholder = "Search..." }) => {
  const [currentPlaceholder, setCurrentPlaceholder] = useState('')
  const [placeholderIndex, setPlaceholderIndex] = useState(0)
  const [isTyping, setIsTyping] = useState(true)

  // Different placeholder suggestions based on context
  const placeholderTexts = [
    "Search AI tools...",
    "Find GPT models...", 
    "Discover image AI...",
    "Search by category...",
    "Find ML platforms...",
    "Explore AI APIs..."
  ]

  // Typewriter effect for placeholder
  useEffect(() => {
    if (!searchTerm) {
      const currentText = placeholderTexts[placeholderIndex]
      
      if (isTyping) {
        if (currentPlaceholder.length < currentText.length) {
          const timeout = setTimeout(() => {
            setCurrentPlaceholder(currentText.slice(0, currentPlaceholder.length + 1))
          }, 100)
          return () => clearTimeout(timeout)
        } else {
          // Pause before deleting
          const timeout = setTimeout(() => {
            setIsTyping(false)
          }, 2000)
          return () => clearTimeout(timeout)
        }
      } else {
        if (currentPlaceholder.length > 0) {
          const timeout = setTimeout(() => {
            setCurrentPlaceholder(currentPlaceholder.slice(0, -1))
          }, 50)
          return () => clearTimeout(timeout)
        } else {
          // Move to next placeholder
          setPlaceholderIndex((prev) => (prev + 1) % placeholderTexts.length)
          setIsTyping(true)
        }
      }
    }
  }, [currentPlaceholder, placeholderIndex, isTyping, searchTerm, placeholderTexts])

  // Reset animation when user starts typing
  useEffect(() => {
    if (searchTerm) {
      setCurrentPlaceholder('')
    }
  }, [searchTerm])

  return (
    <div className="relative mb-8">
      <div className="glass-card rounded-2xl p-1">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 sm:pl-4 flex items-center pointer-events-none">
            <svg className="h-4 w-4 sm:h-5 sm:w-5 text-white/60" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 sm:pl-12 pr-10 sm:pr-4 py-3 sm:py-4 bg-transparent text-white placeholder-white/60 border-none outline-none text-sm sm:text-lg focus:ring-2 focus:ring-white/20 rounded-xl transition-all duration-300"
            placeholder={searchTerm ? placeholder : currentPlaceholder}
          />
          <div className="absolute inset-y-0 right-0 pr-3 sm:pr-4 flex items-center">
            {searchTerm ? (
              <button
                onClick={() => setSearchTerm('')}
                className="text-white/60 hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-white/50 rounded-lg p-1"
                aria-label="Clear search"
              >
                <svg className="h-4 w-4 sm:h-5 sm:w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            ) : (
              <div className="flex items-center space-x-1 text-white/40">
                <div className={`w-0.5 h-4 bg-white/60 animate-pulse ${isTyping ? 'opacity-100' : 'opacity-0'}`}></div>
                <span className="text-xs hidden sm:inline">Type to search</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchBar
